import React, { useCallback, useState } from 'react';
import { t } from '@lingui/core/macro';

import { Box, Paragraph } from '@rover/kibble/core';

import FlatButton from './FlatButton';

const LINE_HEIGHT = 24;

type Props = {
  text: string;
  numberOfLines: number;
  onReadMore: () => void;
} & Partial<React.ComponentProps<typeof Paragraph>>;

const OverflowTextWrapper = ({
  text,
  numberOfLines = 4,
  onReadMore,
  ...props
}: Props): JSX.Element => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false);

  const paragraphStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    wordBreak: 'break-word',
    'white-space': 'pre-line',
    '-webkit-line-clamp': `${numberOfLines}`,
    '-webkit-box-orient': 'vertical',
  };

  const measurementRef = useCallback((node) => {
    if (node) {
      const { height } = node.getBoundingClientRect();
      if (Math.round(height / LINE_HEIGHT) > numberOfLines) {
        setIsTruncated(true);
      }
    }
  }, []);

  const handleOnReadMore = (event): void => {
    event.preventDefault();
    onReadMore();
  };

  return (
    <>
      <Box ref={measurementRef}>
        <Paragraph
          sx={isTruncated ? paragraphStyle : undefined}
          webProps={{ maxWidth: '100%' }}
          {...props}
        >
          {text}
        </Paragraph>
      </Box>
      {isTruncated && (
        <Box>
          <FlatButton onClick={handleOnReadMore}>{t`Read more`}</FlatButton>
        </Box>
      )}
    </>
  );
};

export default OverflowTextWrapper;
